











import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Point, Vector } from "../../../../../../../base/domain/drawing";
import { DragKinds } from "../../../../../../../base/components/dragging";
import {
  FormatPageStructureEditor,
  IFormatObjectEditable,
} from "../../../../../../domain/editableFormat";
import { instanceOfIRectangleCoordinateEditable, instanceOfIVectorCoordinateEditable } from "../../../../../../domain/editableFormat/properties";
import { FormatPageMouseTrackableMixin } from "../mixins";

@Component
export default class ObjectsRelocator extends Mixins(FormatPageMouseTrackableMixin) {
  @Prop()
  source: IFormatObjectEditable;

  @Prop()
  event: PointerEvent;

  @Prop()
  kind: DragKinds;

  @Emit()
  finished() {}

  data() {
    return {
      from: null as Point,
    };
  }
  from: Point;

  created(): void {
    this.from = this.toClientLocation(this.pageElement, this.event);
  }

  handleMouseEntered(event: PointerEvent): void {
    this.onMouseEntered(this.pageElement, event);
    this.update(event);
  }

  handleMouseMoved(event: PointerEvent): void {
    this.onMouseMoved(this.pageElement, event);
    this.update(event);
  }

  handleMouseLeaved(event: PointerEvent): void {
    this.onMouseLeaved(this.pageElement, event);
  }

  handleMousePressed(event: PointerEvent): void {
    this.onMousePressed(this.pageElement, event);
  }

  handleMouseReleased(event: PointerEvent): void {
    this.onMouseReleased(this.pageElement, event);
    this.finish(true);
  }

  private update(event: PointerEvent): void {
    if (!this.from || !(event.buttons & 0x1)) { // IEでmouseenterが後から来るパターンではbuttonsも立ったままで来てる.fromがない場合は更新しない.
      return;
    }
    this.writePropertyWhenValid(s => s.setOffsets({
      source: this.source,
      relocatingOffset: Point.to(this.offset),
      transformingRatesFromCenter: {
        x: 1,
        y: 1,
        width: 1,
        height: 1,
      },
    }));
  }

  private get offset(): Point {
    return this.mouseLocation.subtract(this.from ? this.from : new Point(0, 0));
  }

  private get isOffset(): boolean {
    return (this.offset.x !== 0)
        || (this.offset.y !== 0);
  }

  private finish(shouldApply: boolean = false): void {
    this.writePropertyWhenValid(s => {
      const editor = s as FormatPageStructureEditor;
      editor.setOffsets();
      if (shouldApply && this.isOffset) {
        Enumerable.from(editor.getObjects())
          .where(o => o && o.isSelected())
          .toArray()
          .forEach(o => this.relocateObject(editor, o));
      }
    });
    this.from = null;
    this.finished();
  }

  private relocateObject(editor: FormatPageStructureEditor, object: IFormatObjectEditable): void {
    const clone = object.clone() as IFormatObjectEditable;
    if (instanceOfIRectangleCoordinateEditable(clone)) {
      clone.location().setValue(Point.to(Point.from(clone.location().getValue()).add(this.offset)));
    } else if (instanceOfIVectorCoordinateEditable(clone)) {
      clone.vector().setValue(Vector.to(Vector.from(clone.vector().getValue()).move(this.offset)));
    }
    editor.updateObject(clone);
  }

  @Watch("isMouseTracking")
  onMouseTrackingChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.finish(false);
    }
  }
}
